import { createFileRoute } from "@tanstack/react-router";
import { McpAdminPage } from "@/features/connect-ai/mcp-admin-page";
import { mcpAdminSearchSchema } from "@/features/connect-ai/mcp-admin-search";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/mcp")({
	validateSearch: (search) => mcpAdminSearchSchema.parse(search),
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.system.mcp", location.pathname);
	},
	component: McpAdminPage,
});
